import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductimageService {

  ApiURL = environment.ApiURL + '/admin';
  public headers_token: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  getProductImages(productId: number): Observable<any> {
    return this.http.get(this.ApiURL + '/ProductImage/' + productId, { headers: this.headers_token });
  }

  addProductImages(data: any): Observable<any> {
    let imgfile: File;
    imgfile = data.productImgObj;
    let formData = new FormData();
    formData.append("ProductID", data.ProductID);
    formData.append("Title", data.Title);
    formData.append("productImgObj", imgfile);
    return this.http.post(this.ApiURL + '/ProductImage/addProductImage', formData);
  }

  deleteProductImage(id: number): Observable<any> {
    return this.http.delete(this.ApiURL + '/ProductImage/' + id, { headers: this.headers_token });
  }
}
